module.exports = __webpack_public_path__ + "static/media/dot.e49a11ae.svg";